export const getVideoUrl = (token: string): string => {
  return `https://klleon-media.s3.ap-northeast-2.amazonaws.com/media/public/previewer/video/720p24/${token}.mp4`;
};

export const getImageUrl = (token: string): string => {
  return `https://klleon-media.s3.ap-northeast-2.amazonaws.com/media/public/previewer/image/720/${token}.jpg`;
};

export const getAudioUrl = (token: string): string => {
  return `https://klleon-media.s3.ap-northeast-2.amazonaws.com/media/public/previewer/audio/default/${token}.mp3`;
};

export const getExtension = (fileName: string, mediaType: string): string => {
  if (mediaType === 'video') {
    return `${fileName}.mp4`;
  } else if (mediaType === 'image') {
    return `${fileName}.jpg`;
  } else {
    return `${fileName}.mp3`;
  }
};

export const getMediaUrl = (token: string): string => {
  if (token.indexOf('audio') > -1) {
    return getAudioUrl(token);
  } else if (token.indexOf('video') > -1) {
    return getVideoUrl(token);
  } else {
    return getImageUrl(token);
  }
};
